import api from './api';

interface IGetVacanciesPayload {
  division?: string;
  search?: string;
  group?: string;
  grade?: string;
  status?: string;
  responsible?: string;
  showOnlyMyVacancies?: boolean;
  showPrivateVacancies?: boolean;
}

async function getVacanciesAPI({
  division,
  search,
  group,
  grade,
  status,
  responsible,
  showOnlyMyVacancies,
  showPrivateVacancies,
}: IGetVacanciesPayload) {
  const response = await api.get('admin_vacancy/', {
    params: {
      mode: 'normal',
      division,
      search,
      group,
      grade,
      status,
      responsible,
      ownVacancies: showOnlyMyVacancies,
      private: showPrivateVacancies,
    },
  });
  return response?.data;
}

export default getVacanciesAPI;
